import React, { Component } from 'react';
import { Button, TextField } from 'react-md';
 
class Filter extends Component {
    
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {

        return (
            <div className="md-grid">
                <TextField id="busca" name="busca" label="Busca" lineDirection="center" 
                    className="md-cell md-cell--bottom tw-filter-textfield" placeholder={this.props.placeholder} 
                    onChange={this.handleChangeFilter}
                    inlineIndicator={
                        <Button icon disabled className="text-fields__inline-btn">
                            search
                        </Button>
                    }/>
            </div>
        )
    }

    handleChangeFilter = filter => {
        this.props.onSearch(filter)
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/Filter.js